import { render, staticRenderFns } from "./GeneralHistory.vue?vue&type=template&id=f1126fce&"
import script from "./GeneralHistory.vue?vue&type=script&lang=js&"
export * from "./GeneralHistory.vue?vue&type=script&lang=js&"
import style0 from "./GeneralHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports